import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ContractProfitabilityAnalysisDialogComponent } from '../dialog/dialog.component';
import { LooseObject } from '../../../../objects/loose-object';
import { map } from 'rxjs/operators';
import { ProfitabilityAnalystService } from '../../../../services/profitability-analyst.service';
import { filled } from '../../../../shared/utils/common';

@Component({
  selector: 'contract-profitability-analysis-button',
  template: `<button
    *ngIf="isUserProfitabilityEnabled"
    id="txtActualProfit"
    class="btn mr-2"
    [ngClass]="(profitMargin.profit > 0) ? 'btn-success' : 'btn-danger'"
    (click)="showProfitability()"
    matTooltip="{{'profitability_analysis' | translate}}" >
     {{  ( profitMargin.profit | currency: {decimal_places: 2} ) }}
     ({{ profitMargin.margin }}%)
  </button>`
})

export class ContractProfitabilityAnalysisButtonComponent {

  @Input('record') record: LooseObject;

  @Input('module') module: string;

  @Output() updatedAmountToInvoiceEmitter = new EventEmitter<number>();

  profitMargin: LooseObject = {
    profit: 0,
    margin: 0,
  };

  isUserProfitabilityEnabled: boolean = false;

  profitabilityAnalysisData: LooseObject = {};

  /**
   * @param {MatDialog}
   */
  constructor(
    private dialog: MatDialog,
    protected pofitabilityAnalystService: ProfitabilityAnalystService
  ) {}

  ngOnInit() {
  }

  ngOnChanges() {
    this.getProfitabilityAnalysis();
  }

  showProfitability(): void {
    this.dialog.open(ContractProfitabilityAnalysisDialogComponent, {
      data: this.profitabilityAnalysisData,
      minWidth: '95vw',
      disableClose: true,
    });
  }

  /**
   * Pulls the api for computing the margin and the profit for display
   */
  private getProfitabilityAnalysis(): void {
    if (filled(this.module) && filled(this.record)) {
      this.pofitabilityAnalystService.getProfitabilityAnalysis(this.module, this.record.id)
        .subscribe( (analysis) => {
          this.isUserProfitabilityEnabled = true;
          this.profitabilityAnalysisData = analysis;
          this.profitMargin = {
            profit: analysis.profitability_profit,
            margin: analysis.profitability_margin,
          };
        });
    }
  }
}

export interface AnalysisDisplay {
  margin: number;
  profit: number;
};
